/**
 * PCMコード区分
 */
export const PCM_CD_DIVISION = {
  /** 商談進捗区分 */
  NEGOTIATION_PROGRESS_TYPE: '0125',
  /** メール送信タイプ */
  SEND_METHOD_TYPE: '0173',
  /** パーミッション区分 */
  PERMISSION_TYPE: '0174',
  /** メールパーミッション区分 */
  MAIL_PERMISSION_TYPE: '0175',
  /** 事前準備架電 */
  BEF_CALL: '0177',
  /** ヒアリング */
  HEARING: '0178',
  /** 事前準備照会 */
  REF_AGREE_STATUS: '0179',
  /** 事前の動画視聴有無フラグ */
  WATCH_VIDEO_FLG: '0180',
  /** 事前顧客照会同意ステータス */
  REF_CUSTOMER_AGREE_STATUS: '0181',
  /** ヒアリング(WEB) */
  HEARING_WEB: '0182',
  /** クルー／Web識別区分（当日区分含む） */
  WEB_CREW_KIND_WITH_TODAY_CHG_FLG: '0183',
  /** 登録情報外部連携業務(モバイル:SB) */
  EXTERNAL_LINK_WORK_TYPE_MOBILE_SB: '0184',
  /** 登録情報外部連携業務(インターネット・固定電話) */
  EXTERNAL_LINK_WORK_TYPE_INTERNET_LANDLINE_PHONE: '0185',
  /** 登録情報外部連携業務(おうちでんき) */
  EXTERNAL_LINK_WORK_TYPE_ELECTRICITY: '0186',
  /** 登録情報外部連携業務(モバイル:YM) */
  EXTERNAL_LINK_WORK_TYPE_MOBILE_YM: '0187',
  /** ブランド */
  BRAND_CD: '0190',
  /** ヒアリング(CREW) */
  HEARING_CREW: '0191',
  /** LINEステータス */
  LINE_CONTACT_FLG: '0213',
  /** 「ヒアリングQR」ステータス */
  HEARING_QR: '0214',
} as const;
export type PcmCdDivision = typeof PCM_CD_DIVISION[keyof typeof PCM_CD_DIVISION];

/********************************************************************
 * ここからPCMコードリスト定数定義
 *******************************************************************z*/
/** アクションステータス区分 */
export const ACTION_STATUS_TYPE = {
  /** 選択なし */
  VISIT_NOT_ENTERED: '0100',
  /** 来店予定 */
  VISIT_RESERVATION: '0101',
  /** 来店なし（顧客からの連絡なし） */
  NOT_VISIT: '0102',
  /** 来店予定日確認中 */
  COMFIRMING_SCHEDULED_VISIT_DATE: '0103',
  /** 来店完了 */
  VISIT_COMPLETED: '0191',
  /** 選択なし */
  CALL_NOT_ENTERED: '0200',
  /** 再架電 */
  RE_CALL: '0201',
  /** 繋がらない（留守電入力） */
  ANSWERING_MACHINE_INPUT: '0202',
  /** 繋がらない（留守電無し） */
  ANSWERING_MACHINE_NONE: '0203',
  /** 要架電 */
  CALL_REQUIRED: '0204',
  /** 架電不要 */
  NO_NEED_TO_CALL: '0205',
  /** 架電完了 */
  CALL_COMPLETED: '0291',
  /** 選択なし */
  CONVERSATION_NOT_ENTERED: '0300',
  /** 電話あり（未会話） */
  NO_CONVERSATION: '0301',
  /** 電話あり（会話） */
  CONVERSATION: '0392',
};
/** アクションステータス区分 */
export type ActionStatusType = typeof ACTION_STATUS_TYPE[keyof typeof ACTION_STATUS_TYPE];

/** 日付タイプ区分 */
export const DAY_TYPE = {
  /** 指定なし */
  DESIGNATION_NONE: '0',
  /** 平日 */
  WEEK_DAYS: '1',
  /** 休日 */
  HOLI_DAY: '2',
  /** 日付指定 */
  DATE_DESIGNATION: '3',
};
/** 日付タイプ区分 */
export type DayType = typeof DAY_TYPE[keyof typeof DAY_TYPE];

/** アクション予定時間区分 */
export const ACTION_TIME_TYPE = {
  /** 時間指定 */
  TIME_DESIGNATION: '01',
  /** AM */
  AM: '02',
  /** PM */
  PM: '03',
};
/** アクション予定時間区分 */
export type ActionTimeType = typeof ACTION_TIME_TYPE[keyof typeof ACTION_TIME_TYPE];

/** 中分類 商品 */
export const MIDDLE_CATEGORY_COMMON = {
  /** モバイル */
  MOBIL: '01',
  /** インターネット・固定電話 */
  INTERNET: '02',
  /** おうちでんき */
  ELECTRICITY: '03',
};

/** ブランドコード */
export const BRAND_CODE = {
  /** 共通 */
  CM: '0',
  /** SB */
  SB: '1',
  /** YM */
  YM: '4',
};
